import { render, staticRenderFns } from "./CreateGlassVariation.vue?vue&type=template&id=2c1f1379&"
import script from "./CreateGlassVariation.vue?vue&type=script&lang=js&"
export * from "./CreateGlassVariation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports